import { Dict } from '@se/se.ui.html5';
import { GridUserPreference } from 'estensa-module';

export interface IdDescriptionItem {
    id: string;
    description: string;
}

export interface Rhythm extends IdDescriptionItem {
}

export interface Sex extends IdDescriptionItem {
    code: string;
}

export enum UploadingMode {
    Patient = 0, // Store Dicom e Chiamate al DB
    StudyPartial = 1, // Store Dicom, ma l'id nn è ancora completo e l'aggiornamento del DB sarà successivo
    StudyComplete = 2, // Store Dicom e Chiamate al DB
}

export enum ExternalDocFamilyType {
    Patient = 0, // Documento associato al paziente
    Study = 1, // Documento associato alla prestazione
}

export interface ExternalDocument {
    id: string;
    accessionNumber: string;
    addToPatientDossier: boolean;
    creationDateTime: Date;
    docByteArray: number[];
    docBase64ByteArray: string; // byte array in base64 per l'upload....
    docType: string; // consenso informaato, referto.....
    eprDescription: string;
    eventDateTime: Date;
    fileName: string;
    fileType: number; // 1 - PDF, 2 - JPEG, 3 - PNG
    guidExaminationList: string[];
    guidPatient: string;
    instanceNumber: string;
    issuerOfPatientID: string;
    modality: string;
    mode: UploadingMode;
    patientBirthDate: Date;
    patientID: string;
    patientName: string;
    patientSex: string;
    patientSurname: string;
    referringPhysicianName: string;
    sopInstanceUID: string;
    seriesInstanceUID: string;
    seriesNumber: string;
    studyDateTime: Date;
    studyID: string;
    studyInstanceUID: string;
    userID: string;
}

export interface HiararchicalExternalDocument {
    id: string; // guid del paziente o dell'examonation a seconda che si lavori per il primo o per il secondo
    type: ExternalDocFamilyType; // Tipo di documento, paziete o studio
    description: string;
    linkedExternalDocuments: ExternalDocument[];
}

export interface ExternalDocSearchInfo {
    patient: IdDescriptionItem;
    examinations: IdDescriptionItem[];
}

export interface ExternalDocPatientInfo {
    // Info che servono pe raggiungere nuovi documenti (da passare al server)
    guidPatient: string;
    patientName: string;
    patientSurname: string;
    patientSex: string;
    patientID: string;
}

export interface EstensaUser {
    id: string;
    domain: string;
    userName: string;
    descName: string;
    description: string;
    name: string;
    surname: string;
    userSessionGuid?: string;
}

export interface SessionInformation {
    idUser: string;
    idHost: string;
    hostName: string;
}

export interface User {
    id: string;
    fullName: string;
    userName: string;
}

// Setting Utente

export interface AdminUserPagePreference {
    filters?: string;
    toolbar?: string;
    searchType?: string;
    isRightPanelVisibleOnStart?: boolean;
}

export interface AdminPagesUserPreference {
    execution?: AdminUserPagePreference;
}

export interface CollectionSearchGrid {
    isDefault: boolean;
    name: string;
    searchParams: string;
}

export interface SearchGridUserPreference {
    visitWorklistSearchGrid?: { collection: CollectionSearchGrid[] };
    ecgWorklistSearchGrid?: { collection: CollectionSearchGrid[] };
    specialtyWorklistSearchGrid?: { collection: CollectionSearchGrid[] };
}

export interface UserPreferences {
    gridUserPreference?: GridUserPreference;
    searchGridUserPreference?: SearchGridUserPreference;
    adminPagesUserPreference?: AdminPagesUserPreference;
}

export interface UserMenu {
    profileNames: string;
    profileDescriptions: string;
    items: UserMenuItem[];
    bypassServerConfiguration: boolean;
}

interface UserMenuItem {
    identifier: string;
    category: string;
    isVisible: boolean;
    webIdentifier: string;
    groupByCategory: boolean;
}

export interface UserConfiguration {
    menu: UserMenu;
    preferences: UserPreferences;
    authorizations: Dict<boolean>;
}

// Code dell'MPS
export interface Queue {
    businessUnit_Description: string;
    businessUnit_ID?: string;
    check: number;
    clientDescription: string;
    clientID?: number;
    clientIP: string;
    copies?: number;
    eND_Time: Date;
    external_ID: string;
    failed: number;
    failureDescription: string;
    failureReason: string;
    groupID: number;
    hasContent: boolean;
    hostname: string;
    enD_Time?: Date;
    iN_Burner_Time?: Date;
    iN_Creating_Time?: Date;
    iN_Pending_Time?: Date;
    iN_Time: Date;
    jobDescription: string;
    jobID: number;
    jobPriority?: number;
    mPSDescription: string;
    mediaGroupOrdinalNumber?: number;
    mediaGroupTotalNumber?: number;
    mediaGroupUID?: string;
    mediaType: string;
    modalities: string;
    multi?: number;
    multiCD: string;
    patientBirthDate?: Date;
    patientName: string;
    patientSex: string;
    queueOrder: number;
    robotDescription: string;
    robot_GUID?: string;
    server_GUID?: string;
    status: number;
    statusDetails: string;
    studies: string;
    tags: string;
    useBUCover?: boolean;
    validateTime: string;
    writePermission: boolean;
}
